module.exports = __webpack_public_path__ + "img/Envelope.56fbdd8d.svg";